@if (articles.length) {
<p-button icon="fa-solid fa-book-open" [text]="true" [rounded]="true" pTooltip="Documentation de cet écran"
    tooltipPosition="left" (onClick)="onClickHelp($event)"></p-button>

<!-- `doc-ui` est porté ici : le popover sort du flux (`appendTo="body"`) et
     n'hériterait de rien. -->
<p-popover #helpPopover appendTo="body">
    <div class="doc-ui doc-pop">

        <!-- Les articles de l'écran, et la porte de l'assistant. La liste ne
             dépend d'aucun service : elle reste utilisable quand l'assistant
             ne répond pas. -->
        @if (!inConversation) {
        <div class="doc-pop__head">
            <span class="doc-pop__label">Sur cet écran</span>
            <span class="doc-pop__screen">{{ screenLabel }}</span>
        </div>

        <div class="doc-pop__list no-scrollbars">
            @for (article of articles; track article.id) {
            <a class="doc-pop__item" (click)="onClickArticle(article)">
                <div class="doc-pop__item-top">
                    <span class="doc-pop__item-title">{{ article.title }}</span>
                    <app-documentation-type-badge [type]="article.type"></app-documentation-type-badge>
                </div>
                @if (article.question) {
                <div class="doc-pop__item-question">{{ article.question }}</div>
                }
            </a>
            }
        </div>

        <div class="doc-pop__ai">
            <app-assistant-composer placeholder="Poser une question sur cet écran" severity="help"
                (send)="onSendQuestion($event)"></app-assistant-composer>
            <div class="doc-pop__hint">
                <i class="bi bi-ai-sparkles-solo"></i>L'assistant répond à partir du manuel et cite ses articles.
            </div>
        </div>
        }

        <!-- La conversation, à la place de la liste — le retour la restaure -->
        @if (inConversation) {
        <div class="doc-pop__head">
            <p-button label="Aide sur cet écran" icon="pi pi-arrow-left" severity="secondary" [text]="true"
                [rounded]="true" (onClick)="onClickBackToArticles()"></p-button>
            <span class="doc-pop__assistant"><i class="bi bi-ai-sparkles-solo"></i>Assistant</span>
        </div>

        <div class="doc-pop__conv">
            <app-documentation-assistant #assistant class="h-auto" threadClass="doc-pop__thread no-scrollbars"
                [context]="assistantContext" (openDoc)="onOpenDoc($event)"></app-documentation-assistant>
        </div>
        }

        <div class="doc-pop__foot">
            <a (click)="onClickHome()"><i class="fa-solid fa-book-open"></i>Toute la documentation</a>
            @if (supportAvailable) {
            <a class="doc-pop__support" (click)="onClickSupport()"><i class="fa-solid fa-life-ring"></i>Signaler un
                problème</a>
            }
        </div>
    </div>
</p-popover>
}
